export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const formatDate = (date) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('pt-BR').format(new Date(date));
};

export const formatDateBR = (dateString) => {
  if (!dateString) return '';
  const parts = dateString.split('T')[0].split('-');
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
};
